export const environment = {
  production: true,
  baseURL: "https://loja.gplustogo.com.br/",
  headers: {
    Auth: "Basic f159a34cb3c40d3bc5b888edba9e61d6a0fccc36e6830ccef16aabbbb7c7",
  },
};
